var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mt-2 mb-2"},[_c('DiamondTag',{attrs:{"tag-text":this.category}}),_c('div',{staticClass:"list-text",staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(this.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }